import { axiosPublic, axiosPrivate } from "../utils";
import { toast } from 'react-toastify';

export const joinLab = async (data) => {
    const { invitationCode } = data;
    try {
        const res = await axiosPrivate.post('lab-employee/join-lab', {
            invitationCode: invitationCode
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        toast.success(res.data.message);
        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}